module.exports = __webpack_public_path__ + "../static/img/switch-fail.1f0d6753.png";